/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Toggle_Filters_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle filters" |
*
* @param {Manual_Qc_Toggle_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_toggle_filters_label = /** @type {((inputs?: Manual_Qc_Toggle_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Toggle_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher/masquer les filtres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filter umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva i filtri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить фильтры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar filtros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换筛选器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フィルターを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़िल्टर टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar filtros")
	return /** @type {LocalizedString} */ ("Toggle filters")
});